var overArg = require('./_overArg');

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

module.exports = getPrototype;



//////////////////
// WEBPACK FOOTER
// (webpack)-merge/~/lodash/_getPrototype.js
// module id = 127
// module chunks = 9